import React, { useContext } from 'react';
import { Link } from 'gatsby';

import { MainButton } from 'components/Button';
import { LayoutContext } from 'components/Layout/context/layout-context';

import { URLEnums } from '../../../enum/URLEnum';
import { IFileItem, FileInput } from './FileInput';

interface Props {
  inputRef: React.RefObject<HTMLInputElement>;
  files: IFileItem[];
  isFileSizeValid: boolean;
  isFilesMaxCountValid: boolean;
  onChange: () => void;
  onItemChange: (fileName: string) => void;
  onRemove: () => void;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled: boolean;
  sending: boolean;
  contactFormRole: string;
}

export const Attachment = ({
  inputRef,
  files,
  isFileSizeValid,
  isFilesMaxCountValid,
  onChange,
  onItemChange,
  onRemove,
  onClick,
  disabled,
  sending,
  contactFormRole,
}: Props) => {
  const PLEASE_BE_INFORMED =
    'Please be informed that when you click the Send button Itransition Group will process your personal data in accordance with our ';
  const PRIVACY_LINK = 'Privacy notice';
  const PURPOSE = ' for the purpose of providing you with appropriate information.';
  const AGREE_SEND = 'Send';

  const isForm = useContext<boolean>(LayoutContext);

  const SubmitButton = (
    <MainButton
      className="primary"
      component="button"
      type="submit"
      form="contact-form"
      onClick={onClick}
      disabled={!isFileSizeValid || disabled}
      label="Submit"
    >
      <span style={{ opacity: sending ? 0 : 1 }} className="button-font-small">
        {AGREE_SEND}
      </span>
      {sending && <span className="spinner3p" />}
    </MainButton>
  );

  const Information = (
    <p className="body-3">
      {PLEASE_BE_INFORMED}
      <Link to={URLEnums.PrivacyPolicy} className="contact-form-privacy-link">
        {PRIVACY_LINK}
      </Link>
      {PURPOSE}
    </p>
  );

  const FileAttachment = (
    <FileInput
      inputRef={inputRef}
      files={files}
      onChange={onChange}
      onItemChange={onItemChange}
      onRemove={onRemove}
      isFileSizeValid={isFileSizeValid}
      isFilesMaxCountValid={isFilesMaxCountValid}
      disabled={disabled}
      contactFormRole={contactFormRole}
    />
  );

  return isForm ? (
    <div className="contact-attachment form">
      <div className="file-attachment">{FileAttachment}</div>
      <div className="information-submit">
        {Information}
        {SubmitButton}
      </div>
    </div>
  ) : (
    <div className="contact-attachment landing">
      {Information}
      {FileAttachment}
      {SubmitButton}
    </div>
  );
};
